import styled from "styled-components"

export const Container = styled.div`
  background-color: white;
  border: 1px dashed #e5e7eb; // Changed to dashed border
  border-radius: 8px;
  padding: 24px;
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen', 'Ubuntu', 'Cantarell', sans-serif;
`

export const HeaderContainer = styled.div`
  margin-bottom: 16px;
`

export const BankName = styled.h1`
  font-size: 16px;
  font-weight: 600;
  color: #4B5563;
  margin: 0 0 4px 0;
`

export const Subtitle = styled.p`
  font-size: 14px;
  color: #6b7280;
  margin: 0;
`

export const TopDivider = styled.hr`
  border: none;
  border-top: 1px dashed #e5e7eb;
  margin: 0 0 24px 0;
`

export const DescriptionLabel = styled.h2`
  font-size: 14px;
  font-weight: 600;
  color: #1f2937;
  margin: 0 0 8px 0;
`

export const DescriptionText = styled.p`
  font-size: 14px;
  color: #6b7280;
  margin: 0 0 24px 0;
`

export const Row = styled.div<{ $isTotal?: boolean }>`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 16px;
`

export const Label = styled.span<{ $isTotal?: boolean }>`
  font-size: 14px;
  color: ${(props) => (props.$isTotal ? "#1f2937" : "#374151")};
  font-weight: 600;
  flex: 1;
`

export const Value = styled.span<{ $isTotal?: boolean }>`
  font-size: 14px;
  color: ${(props) => (props.$isTotal ? "#1f2937" : "#6b7280")};
  font-weight: ${(props) => (props.$isTotal ? "700" : "400")};
  flex: 1;
`

export const ContainerInfoHeader = styled.div`
  display: flex;
  gap: 18px;
  align-items: center;
  margin-top: 12px;
`;

export const InfoWrapper = styled.p`
  display: flex;
  gap: 8px;
  border-left: 1px solid #E5E7EB; // Propriedade abreviada
  padding-left: 18px;
  margin: 0;
`;

export const LabelHeader = styled.span`
  color: #111827;
  font-weight: 600;
`;

export const ValueHeader = styled.span`
  color: #6b7280;
`;